module.exports = window["popupMaker"]["coreData"];